<div
  class="widget wiki"
  *appHasPermission="{
    permissions: [permissions.allPermissions.FAULT_WIKI_READ],
  }"
>
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex justify-content-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (wikiFaults) {
      <p-table
        [scrollable]="true"
        [columns]="WIKI_COLS"
        [value]="wikiFaults"
        [paginator]="true"
        [rows]="rows"
        [rowsPerPageOptions]="paginatorOptions.ROWS_PER_PAGE"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="'common.page_report' | translate"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        [totalRecords]="totalRecords"
        [first]="first"
        [loading]="tableLoading()"
        (onLazyLoad)="onLazyLoad($event)"
        class="fullTable tableHeaderAlignTop"
      >
        <ng-template #caption>
          <div class="flex w-full justify-content-end">
            <input
              pInputText
              type="text"
              (input)="filterGlobal($event)"
              [placeholder]="translate.instant('common.search')"
            />
          </div>
        </ng-template>
        <ng-template #header let-columns>
          <tr>
            @for (col of columns; track col) {
              @if (col.sortable === false) {
                <th>{{ col.header | translate }}</th>
              } @else {
                <th [pSortableColumn]="col.field">{{ col.header | translate }}<p-sortIcon [field]="col.field" /></th>
              }
            }
          </tr>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>
              <p-select
                [options]="manufacturers"
                (onChange)="onManufacturerChange()"
                (onClear)="onManufacturerChange()"
                [placeholder]="translate.instant('wiki.table.filter_manufacturer')"
                [showClear]="true"
                optionValue="id"
                appendTo="body"
                [(ngModel)]="selectedManufacturer"
              >
              </p-select>
            </th>
            <th>
              <p-select
                [options]="filteredModels"
                (onChange)="onModelChange()"
                (onClear)="onModelChange()"
                [placeholder]="translate.instant('wiki.table.filter_model')"
                [showClear]="true"
                optionValue="id"
                appendTo="body"
                [(ngModel)]="selectedModel"
              >
              </p-select>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template #body let-rowData let-columns="columns">
          <tr style="max-height: 95px">
            @for (col of columns; track col) {
              @if (col.field === "faultType") {
                <td>
                  {{ rowData[col.field] | translate }}
                </td>
              } @else if (col.field === "faultText") {
                <td>
                  {{ getFaultDescription(rowData) }}
                </td>
              } @else if (col.field === "manufacturers") {
                <td>
                  @for (manufacturer of rowData[col.field]; track $index) {
                    {{ manufacturer.label }}
                    @if ($index < rowData[col.field].length - 1) {
                      |
                    }
                  }
                </td>
              } @else if (col.field === "models") {
                <td>
                  @for (model of rowData[col.field]; track $index) {
                    {{ model.label }}
                    @if ($index < rowData[col.field].length - 1) {
                      |
                    }
                  }
                </td>
              } @else if (col.field === "fixLink") {
                <td>
                  <app-button
                    [buttonText]="translate.instant('wiki.table.fix_link_button')"
                    (click)="openFixLink(rowData)"
                  >
                  </app-button>
                </td>
              } @else {
                <td>
                  {{ rowData[col.field] }}
                </td>
              }
            }
          </tr>
        </ng-template>
      </p-table>
    }
  }
</div>
